import { get, post } from "./Api";

export function SearchMyCoupon({ data }) {
    return post({ url: `/api/v1/haire/member/priviliage/mycoupon`, data });
}

export function SearchMyCouponOnline({ data }) {
    return post({ url: `/api/v1/haire/member/priviliage/mycoupon/online`, data });
}

export function SearchCouponHistory({ data }) {
    return post({ url: `/api/v1/haire/member/search/history/reward`, data });
}

export function SearchCouponById(couponId) {
    return get({ url: `/api/v1/haire/member/priviliage/coupon/${couponId}` });
}

export function SearchCouponOnlineById(couponId) {
    return get({ url: `/api/v1/haire/member/priviliage/couponOnline/${couponId}` });
}

export function InsertCoupon({ data }) {
    return post({ url: `/api/v1/haire/member/priviliage/insert/coupon`, data });
}

export function CreateQrCode({ data }) {
    return post({ url: `/api/v1/haire/member/priviliage/qrcode/create`, data });
}


export function SearchQrCode({ data }) {
    return post({ url: `/api/v1/haire/member/priviliage/search/qrcode`, data });
}

export function SearchShopCoupon({ data }) {
    return post({ url: `/api/v1/haire/employee/search/coupon`, data });
}

export function CreateCoupon({ data }) {
    return post({ url: `/api/v1/haire/employee/insert/coupon`, data });
}

export function UpdateCoupon({ data }) {
    return post({ url: `/api/v1/haire/employee/update/coupon`, data });
}

export function DeleteCoupon({ data }) {
    return post({ url: `/api/v1/haire/employee/delete/coupon`, data });
}

export function UpdateQrCode({ data }) {
    return post({ url: `/api/v1/haire/employee/update/Qrcode`, data });
}







